import React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  SelectInput,
  BooleanInput,
  ArrayInput,
  SimpleFormIterator,
  required,
  minValue,
  TopToolbar,
  ShowButton,
  DeleteButton,
} from 'react-admin';

const subscriptionPlanTypes = [
  { id: 'free', name: 'Free' },
  { id: 'basic', name: 'Basic' },
  { id: 'pro', name: 'Pro' },
  { id: 'premium', name: 'Premium' },
  { id: 'enterprise', name: 'Enterprise' },
];

const currencies = [
  { id: 'USD', name: 'USD' },
  { id: 'EUR', name: 'EUR' },
  { id: 'RUB', name: 'RUB' },
];

const SubscriptionPlanEditActions = () => (
  <TopToolbar>
    <ShowButton />
    <DeleteButton />
  </TopToolbar>
);

export const SubscriptionPlanEdit = () => {
  return (
    <Edit actions={<SubscriptionPlanEditActions />} title="Редактировать план подписки">
      <SimpleForm>
        <TextInput 
          source="name" 
          label="Название" 
          validate={[required()]} 
          fullWidth 
        />
        <SelectInput
          source="type"
          label="Тип"
          choices={subscriptionPlanTypes}
          validate={[required()]}
          fullWidth
        />
        <TextInput 
          source="description" 
          label="Описание" 
          multiline 
          rows={3}
          fullWidth 
        />
        <NumberInput 
          source="price" 
          label="Цена" 
          validate={[required(), minValue(0)]}
          step={0.01}
        />
        <SelectInput
          source="currency"
          label="Валюта"
          choices={currencies}
          validate={[required()]}
        />
        <NumberInput 
          source="billingPeriodMonths" 
          label="Период оплаты (месяцы)" 
          validate={[required(), minValue(1)]}
        />
        <BooleanInput 
          source="isActive" 
          label="Активен" 
        />
        <NumberInput 
          source="sortOrder" 
          label="Порядок сортировки" 
          validate={[minValue(1)]}
        />
        <ArrayInput source="features" label="Особенности">
          <SimpleFormIterator>
            <TextInput source="key" label="Ключ" />
            <TextInput source="value" label="Значение" />
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Edit>
  );
};
